import { Text, View } from 'react-native';
import { extraSignGlyph } from '@heraion/shared';

import { hiddenFromScreenReader } from '../primitives/hiddenFromScreenReader';
import type { useTheme } from './theme';

// The «−» of an assisted bodyweight load (#213). The field itself is
// magnitude-only (the sign lives on `extraNegative`), so the amber of
// `inputNegative` was the only trace of "assist". This glyph is the second
// signal: drawn over the field's left padding, never part of its value.
// Visual only: the input's own accessibilityLabel says "assisted", so a screen
// reader never vocalises the raw «−» as "minus".
export function AssistSignMark({ theme }: { theme: ReturnType<typeof useTheme> }) {
  const { palette: p, spacing: s, typography: ty } = theme;
  return (
    <View
      pointerEvents="none"
      {...hiddenFromScreenReader()}
      style={{
        position: 'absolute',
        left: s.s3,
        top: 0,
        bottom: 0,
        justifyContent: 'center',
      }}
    >
      <Text style={{ color: p.warn, fontSize: ty.sizes.md, fontWeight: '700' }}>
        {extraSignGlyph(true)}
      </Text>
    </View>
  );
}
